import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from 'locales/fr';
import { defaultCssVariables } from 'core/styled';
import { InputContainer, UnstyledInput } from './Input.style';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as Danger } from './danger.svg';

export type InputUnitType = 'currency' | 'percentage';

export type InputProps = {
    value?: string;
    placeholder?: TranslationKey;
    error?: string;
    name?: string;
    type?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    isTouched?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    (
        {
            value,
            error,
            name = '',
            onChange,
            onBlur,
            placeholder,
            type = 'text',
            disabled,
            isTouched,
            ...rest
        },
        ref,
    ) => {
        const { t } = useTranslation();

        return (
            <div style={{ opacity: disabled ? 0.4 : 1 }}>
                <InputContainer error={error} isTouched={isTouched} data-testid="input-container">
                    <UnstyledInput
                        ref={ref}
                        type={type}
                        value={value}
                        placeholder={placeholder ? t(placeholder) : ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        name={name}
                        disabled={disabled}
                        {...rest}
                    />
                    {error && (
                        <div data-testid="danger-icon">
                            <Danger color={defaultCssVariables.color.bloodyMary} />
                        </div>
                    )}
                    {!error && isTouched && (
                        <div data-testid="check-icon">
                            <Check color={defaultCssVariables.color.emerald} />
                        </div>
                    )}
                </InputContainer>
            </div>
        );
    },
);
Input.displayName = 'Input';
